import { faAngleRight, faGlobe, faMessage, faQuestionCircle } from '@fortawesome/pro-regular-svg-icons'
import { Box, Button, Divider, Flex, Text, Title } from '@mantine/core'
import Link from 'next/link'
import { useRouter } from 'next/router'

import { useUserLogout } from '@flecto/auth'
import { useQueryGetUserLogged } from '@flecto/core/shared'
import { useTranslation } from '@flecto/translations'
import { AvatarUserLogged, Icon } from '@flecto/ui'
import { Page, useMenus } from '@flecto/ui/saas'

import styles from './styles.module.css'

export function PageProfileMobileMenus() {
  const { t } = useTranslation('saas', { keyPrefix: 'profile_mobile' })

  const { data: user } = useQueryGetUserLogged()

  const router = useRouter()
  const logout = useUserLogout()

  const { menusSettings } = useMenus()

  const menusExtra = [
    {
      label: t('page_menu.menu_help_center'),
      path: 'https://intercom.help/flecto/en',
      icon: <Icon icon={faQuestionCircle} />,
    },
    {
      label: t('page_menu.menu_language'),
      path: '/profile/languages',
      icon: <Icon icon={faGlobe} />,
    },
  ]

  return (
    <Page withContainer>
      <Page.Title>{t('page_menu.title')}</Page.Title>
      <Page.Content>
        <Flex
          ml={-5}
          align='center'
          justify='space-between'
          onClick={() => router.push('/profile/user')}
        >
          <Flex gap='md'>
            <AvatarUserLogged h={50} w={50} radius='50%' />
            <Flex direction='column'>
              <Title order={4}>{user?.full_name}</Title>
              <Text c='dimmed'>{user?.email}</Text>
            </Flex>
          </Flex>
          <Icon icon={faAngleRight} size='lg' mr={-4} />
        </Flex>
        <Flex mt='md' direction='column'>
          {menusSettings.map((menu, i) => (
            <Link key={i} href={menu.path} className={styles.menuItem}>
              <Flex align='center' gap='sm'>
                {menu.icon}
                {menu.label}
              </Flex>
              <Icon icon={faAngleRight} />
            </Link>
          ))}
        </Flex>
        <Divider mt='md' />
        <Flex mt='md' direction='column'>
          <Box
            className={styles.menuItem}
            onClick={() => window.Intercom('show')}
          >
            <Flex align='center' gap='sm'>
              <Icon icon={faMessage} />
              {t('page_menu.menu_contact_support')}
            </Flex>
          </Box>
          {menusExtra.map((menu, i) => (
            <Link key={i} href={menu.path} className={styles.menuItem}>
              <Flex align='center' gap='sm'>
                {menu.icon}
                {menu.label}
              </Flex>
              <Icon icon={faAngleRight} />
            </Link>
          ))}
        </Flex>
        <Button
          mt='md'
          fullWidth
          variant='default'
          onClick={() =>
            logout({ logoutParams: { returnTo: window.location.origin } })
          }
        >
          {t('page_menu.menu_logout')}
        </Button>
      </Page.Content>
    </Page>
  )
}
